import React, { FC } from 'react';
import { FormProvider } from 'react-hook-form';
import { Backdrop, CircularProgress } from '@mui/material';

import { CompanyInfoFormProps } from './types';
import LegalInfoSection from './LegalInfoSection';
import AddressSection from './AddressSection';
import BrandSection from './BrandSection';

const CompanyInfoForm: FC<CompanyInfoFormProps> = props => {
  const {
    methods,
    editMode,
    updateEditMode,
    disableEdit = false,
    isLoading,
    companyId,
    countriesList,
    timeZoneList,
    companyDetails,
    getResetAddressSection,
    getResetFunction,
    currencyList,
    getResetLegalInfoSection,
    getResetBrandSection,
    sectors,
    companyConfiguration
  } = props;

  return (
    <>
      {companyDetails && (
        <div className="py-6 px-5 w-full">
          <FormProvider {...methods}>
            <form>
              <LegalInfoSection
                companyDetails={companyDetails}
                editMode={editMode}
                updateEditMode={updateEditMode}
                disableEdit={disableEdit}
                countriesList={countriesList}
                timeZoneList={timeZoneList}
                companyId={companyId}
                currencyList={currencyList}
                getResetLegalInfoSection={getResetLegalInfoSection}
                getResetFunction={getResetFunction}
              />
              <div className="my-14 w-full h-[1px] bg-black opacity-10" />
              <AddressSection
                companyId={companyId}
                countriesList={countriesList}
                timeZoneList={timeZoneList}
                getResetAddressSection={getResetAddressSection}
                getResetFunction={getResetFunction}
                editMode={editMode}
                updateEditMode={updateEditMode}
                companyDetails={companyDetails}
                disableEdit={disableEdit}
              />
              <div className="my-14 w-full h-[1px] bg-black opacity-10" />
              <BrandSection
                companyId={companyId}
                companyDetails={companyDetails}
                getResetBrandSection={getResetBrandSection}
                getResetFunction={getResetFunction}
                sectors={sectors}
                editMode={editMode}
                updateEditMode={updateEditMode}
                disableEdit={disableEdit}
                companyConfiguration={companyConfiguration}
              />
            </form>
          </FormProvider>
        </div>
      )}
      <Backdrop
        sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }}
        open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default CompanyInfoForm;
